export const enDict = {
  'Account recovery requires verified contact information': 
    'Account recovery requires verified contact information',
  'Back to Sign In': 'Back to Sign In',
  'Change Password': 'Change Password',
  Changing: 'Changing',
  Code: 'Code',
  Confirm: 'Confirm',
  'Confirm Password': 'Confirm Password',
  'Confirm Sign Up': 'Confirm Sign Up',
  'Confirm SMS Code': 'Confirm SMS Code',
  'Confirm TOTP Code': 'Confirm TOTP Code',
  'Confirmation Code': 'Confirmation Code',
  Confirming: 'Confirming',
  'Create Account': 'Create Account',
  'Creating Account': 'Creating Account',
  Email: 'Email',
  'Enter your code': 'Enter your code',
  'Enter your username': 'Enter your username',
  'Enter your phone number': 'Enter your phone number',
  'Enter your email': 'Enter your email',
  'Forgot your password?': 'Forgot your password?',
  'Hide password': 'Hide password',
  Loading: 'Loading',
  Username: 'Username',
  'New password': 'New password',
  Password: 'Password',
  'Phone Number': 'Phone Number',
  'Resend Code': 'Resend Code',
  'Reset your password': 'Reset your password',
  'Reset your Password': 'Reset your Password',
  'Send Code': 'Send Code',
  'Send code': 'Send code',
  Sending: 'Sending',
  'Setup TOTP': 'Setup TOTP',
  'Show password': 'Show password',
  'Sign in': 'Sign in',
  'Sign In': 'Sign In',
  'Sign In with Amazon': 'Sign In with Amazon',
  'Sign In with Apple': 'Sign In with Apple',
  'Sign In with Facebook': 'Sign In with Facebook',
  'Sign In with Google': 'Sign In with Google',
  'Sign in to your account': 'Sign in to your account',
  'Create a new account': 'Create a new account',
  'Signing in': 'Signing in',
  Skip: 'Skip',
  Submit: 'Submit',
  Submitting: 'Submitting',
  'Verify Contact': 'Verify Contact',
  Verify: 'Verify',
};
